<!-- 分类页 -->
<template>
  <div class="category-container">
    <!-- 头部搜索区 -->
    <div class="search-bar" v-if="currentActivityConfig.showSearchBar">
      <div class="search-box" @click="$router.push('/searchPopup')">
        <img
          src="https://img.zhujiaxian.com/2024/07/880b5737c5ef4a099f6c5d0326d35d54.png"
          style="margin-left: 15px"
          class="search-img"
        />
        <span style="color: #c5c5c5" class="sear-input">搜索您想要的商品</span>
      </div>
    </div>
    
    <!-- 水平滚动分类导航 -->
    <div class="horizontal-scroll-wrapper" v-if="shouldShowHorizontalScroll" :style="{ top: activityId === 13 || activityId === 16 ? '0' : '50px' }">
      <div 
        id="subScrollView" 
        ref="subScrollView"
        style="white-space: nowrap; display: flex; overflow-x: auto; -webkit-overflow-scrolling: touch;" 
        class="horizontal-scroll-view"
      >
        <div class="scroll-container">
          <div class="category-item" v-for="(item, index) in categoryList" :key="item.categoryId">
            <div @click="(activityId === 13 || activityId === 16) ? onMenuTab(index, item.categoryId, $event) : onProductTab(index, item.categoryId, $event)" :data-index="index" :data-id="item.categoryId">
              <img style="height: 50px;width: 50px;" :src="item.icon" :data-prodid="item.relation" :data-type="item.categoryId">
              <div class="category-title">
                <div :class="(activityId === 13 || activityId === 16) ? (selIndex === index ? 'active' : '') : (getIndex === index ? 'active' : '')">
                  {{item.categoryName}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 主内容区域 -->
    <div class="main-content" :class="{ 'activity-id-13': activityId === 13 || activityId === 16 }">
      <!-- 左侧垂直子分类菜单 -->
      <div class='left-menu' v-if="!shouldUseFullWidthProductContent" style="overflow-y: auto; height: 100%;">
        <div 
          v-for="(item, index) in categoryList" 
          :key="item.categoryId"
          :class="selIndex === index ? 'menu-item active' : 'menu-item'"
          :data-index="index" 
          :data-id="item.categoryId"
          @click="onMenuTab(index, item.categoryId, $event)"
        >
          {{item.categoryName}}
        </div>
      </div>
      
      <!-- 右侧商品列表区域 -->
      <div class="product-content" @scroll="handleScroll" ref="scrollContainer" :class="{ 'full-width': shouldUseFullWidthProductContent }">
        <div class="content-header" style="display: flex;align-items: center;">
          <div class='comprehensive' @click="comprehensive">
            <span :class='zohe === 1 ? "active-text" : ""'>综合</span>
          </div>
          <div class='price' @click="priceSort" style="display: flex;align-items: center;">
            <p>价格</p>
            <div>
              <img v-if="pageState1 === 0 && pageState2 === false" class="imgs" src='../../assets/images/icon/search/top.png' />
              <img v-if="pageState1 === 1 && pageState2 === true" class="imgs" src='../../assets/images/icon/search/top-none.png' />
              <img v-if="pageState1 === 1 && pageState2 === true" class="imgs" src='../../assets/images/icon/search/bottom.png' />
              <img v-if="pageState1 === 0 && pageState2 === false" class="imgs" src='../../assets/images/icon/search/bottom-none.png' />
              <img v-if="pageState1 === null" class="imgs" src='../../assets/images/icon/search/top-none.png' />
              <img v-if="pageState1 === null" class="imgs" src='../../assets/images/icon/search/bottom-none.png' />
            </div>
          </div>
        </div>
        
        <!-- 商品列表 -->
        <div class="product-list">
          <div class="product-item" v-for="item in productList" :key="item.prodId">
            <a 
              href="javascript:void(0)"
              class="product-link"
              @click="clickFn(item.prodId)"
            >
              <div class="product-image">
                <img :src="item.pic" alt="" class="product-img" />
              </div>
              <div class="product-info">
                <span class="product-name">{{ item.prodName }}</span>
                <span class="product-price">
                  <!-- 当活动ID为9时显示指定图片，其他情况下显示¥符号 -->
                  <template v-if="activityId === 9 || activityId === 13">
                    <img :src="'https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png'" alt="" style="width: 14px; height: 14px; display: inline-block; vertical-align: middle; margin-right: 2px;" />
                  </template>
                  <template v-else>
                    ¥
                  </template>
                  <!-- <span class="product-price--big">{{ item.price }}</span> -->
                  <span class="big-num">{{ Math.floor(item.price) }}</span>
                  <span class="small-num">.{{ ((item.price % 1) * 100).toFixed(0).padStart(2, '0') }}</span>
                  <span v-if="activityId === 13" class="product-original-price">￥{{ Number(item.oriPrice).toFixed(2) }}</span>
                </span>
                <a href="javascript:void(0)" class="product-cart"></a>
              </div>
            </a>
          </div>
        </div>
        
        <!-- 加载中提示 -->
        <div v-if="loading" class="loading-wrapper">
          <img src="https://img.zhujiaxian.com/2025/05/21f52dbb86f247098f3b3add676a775b.gif" alt="加载中" class="loading-gif">
        </div>
        
        <!-- 已经到底了提示 -->
        <div v-if="!hasMore && productList.length > 0" class="no-more-tip">
          <span>已经到底了</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetChannelDataApi, GetFenleiDataApi, getcategoryInfo } from "@/https/http";
// 导入URL工具函数
import { getActivityIdFromRoute } from "@/utils/urlUtil";
export default {
  data() {
    return {
      loading: false, // 加载状态控制
      hasMore: true, // 是否还有更多数据
      value: "",
      categoryList: [], // 水平滚动分类导航数据
      subCategoryList: [], // 左侧子分类菜单数据
      currentCategory: {}, // 选中的类别数据
      categoryId: "",
      result: {
        size: 10,
        sort: 0,
        pages: 0,
        current: 1,
        orderBy: 0,
      },
      // 排序状态
      pageState1: null,
      pageState2: false,
      zohe: 0,
      productList: [], // 商品列表数据
      activityId: null, // 活动ID
      scrollLeft: 0, // 水平滚动位置
      getIndex: 0, // 当前选中的顶部分类索引
      selIndex: 0, // 当前选中的左侧菜单索引
      // 活动配置对象，用于管理不同活动ID的特殊处理逻辑
      activityConfig: {
        // 默认配置
        default: {
          showHorizontalScroll: true,  // 是否显示水平滚动导航
          fullWidthProductContent: false, // 是否使用全宽商品列表
          subCategoryStrategy: 'normal', // 子分类加载策略: 'normal'(正常加载), 'topLevel'(使用顶级分类)
          showSearchBar: true  // 是否显示头部搜索区
        },
        // 活动ID为10的特殊配置
        '5': {
          showHorizontalScroll: true,
          fullWidthProductContent: false,
          subCategoryStrategy: 'normal',
          showSearchBar: true  // 显示头部搜索区
        },
        // 活动ID为10的特殊配置
        '10': {
          showHorizontalScroll: false,
          fullWidthProductContent: false,
          subCategoryStrategy: 'topLevel',
          showSearchBar: true  // 显示头部搜索区
        },
         // 活动ID为9的特殊配置
        '9': {
          showHorizontalScroll: false,
          fullWidthProductContent: true,
          subCategoryStrategy: 'topLevel',
          showSearchBar: false  // 不显示头部搜索区
        },
        // 活动ID为8的配置（保持原有行为）
        '8': {
          showHorizontalScroll: true,
          fullWidthProductContent: false,
          subCategoryStrategy: 'normal',
          showSearchBar: true  // 显示头部搜索区
        },
        // 可以在这里添加更多活动ID的配置
         // 活动ID为9的特殊配置
        '12': {
          showHorizontalScroll: true,
          fullWidthProductContent: false,
          subCategoryStrategy: 'topLevel',
          showSearchBar: false  // 不显示头部搜索区
        },
         '13': {
           showHorizontalScroll: true,
           fullWidthProductContent: true,
           subCategoryStrategy: 'topLevel',
           showSearchBar: false  // 不显示头部搜索区
        },
        // 活动ID为16的特殊配置
        '16': {
            showHorizontalScroll: true,
           fullWidthProductContent: true,
           subCategoryStrategy: 'topLevel',
           showSearchBar: false  // 不显示头部搜索区
        },
      }
    };
  },
  
  // 计算属性，根据当前活动ID获取配置
  computed: {
    // 从全局状态获取活动ID
    globalActivityId() {
      return this.$store.getters.getActivityId;
    },
    
    // 当前活动的配置
    currentActivityConfig() {
      // 如果有当前活动ID的配置则使用，否则使用默认配置
      return this.activityConfig[this.activityId] || this.activityConfig.default;
    },
    
    // 是否显示水平滚动导航
    shouldShowHorizontalScroll() {
      return this.currentActivityConfig.showHorizontalScroll;
    },
    
    // 是否使用全宽商品列表
    shouldUseFullWidthProductContent() {
      return this.currentActivityConfig.fullWidthProductContent;
    },
    
    // 子分类加载策略
    currentSubCategoryStrategy() {
      return this.currentActivityConfig.subCategoryStrategy;
    }
  },
  
  methods: {
    // 综合排序
    comprehensive() {
      this.result.sort = 0;
      this.loadProducts();
    },
    
    // 价格排序
    priceSort() {
      this.pageState1 = this.result.orderBy === 1 ? 0 : 1;
      this.pageState2 = this.result.orderBy === 1 ? false : true;
      this.result.sort = 2;
      this.result.orderBy = this.result.orderBy === 1 ? 0 : 1;
      this.result.current = 1;
      this.productList = [];
      this.hasMore = true;
      this.zohe = 0;
      
      this.loadProducts();
    },
    
    // 跳转商品详情页
    clickFn(id) {
      this.$router.push({ path: "/productDetail", query: { id: id } });
    },
    
    // 滚动加载更多
    handleScroll() {
      const container = this.$refs.scrollContainer;
      if (!container) return;
      
      const { scrollTop, clientHeight, scrollHeight } = container;
      
      // 当距离底部小于60px且不在加载状态时触发加载
      if (scrollHeight - (scrollTop + clientHeight) < 60 && !this.loading && this.result.current < this.result.pages && this.hasMore) {
        this.loading = true;
        this.result.current++;
        this.loadProducts().finally(() => {
          this.loading = false;
        });
      }
    },

    // 加载商品数据
    loadProducts() {
      this.loading = true;
      
      const data = {
        // attribute: 8,
        categoryId: this.categoryId || "",
        current: this.result.current,
        size: this.result.size,
        sort: this.result.sort,
        orderBy: this.result.orderBy,
        pages: this.result.pages,
      };
      
      // 当activityId不等于12和13时才传递h5参数
      if (this.activityId !== 12) {
        data.h5 = this.activityId || 8;
      }
      
      return GetFenleiDataApi(data)
        .then((res) => {
          console.log("商品数据", res);
          let list = [];
          
          if (res.data.current === 1) {
            res.data.records.forEach((element) => {
              list.push(element);
            });
          } else {
            list = this.productList.concat(res.data.records);
          }
          
          this.productList = list;
          this.result.pages = res.data.pages;
          
          // 判断是否还有更多数据
          if (this.result.current >= this.result.pages) {
            this.hasMore = false;
          }
        })
        .catch(error => {
          console.error("加载商品数据失败:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 水平滚动分类点击事件
    onProductTab(index, categoryId, event) {
      this.getIndex = index;
      this.categoryId = categoryId;
      
      // 重置状态
      this.result.current = 1;
      this.productList = [];
      this.hasMore = true;
      
      // 自动滚动，使选中的分类项在可视区域内居中显示
      this.scrollToSelectedCategory(index, event);
      
      // 滚动到顶部
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollTop = 0;
      }
      
      // 加载商品数据
      this.loadProducts();
      
      // 获取子分类数据
      this.loadSubCategories(categoryId);
    },
    
    // 左侧菜单点击事件
    onMenuTab(index, categoryId, event) {
      this.selIndex = index;
      this.categoryId = categoryId;
      
      // 重置状态
      this.result.current = 1;
      this.productList = [];
      this.hasMore = true;
      
      // 自动滚动，使选中的分类项在可视区域内居中显示
      this.scrollToSelectedCategory(index, event);
      
      // 滚动到顶部
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollTop = 0;
      }
      
      // 加载商品数据
      this.loadProducts();
    },
    
    // 自动滚动到选中的分类项
    scrollToSelectedCategory(index, event) {
      // 获取滚动容器和点击的分类项元素
      const scrollView = this.$refs.subScrollView;
      const categoryItem = event.currentTarget;
      
      if (scrollView && categoryItem) {
        // 计算滚动位置，使选中的分类项居中显示
        const scrollLeft = scrollView.scrollLeft;
        const offsetLeft = categoryItem.offsetLeft;
        const categoryItemWidth = categoryItem.offsetWidth;
        const scrollViewWidth = scrollView.offsetWidth;
        
        // 计算目标滚动位置
        const targetScrollLeft = offsetLeft - (scrollViewWidth / 2) + (categoryItemWidth / 2);
        
        // 使用setTimeout确保DOM已更新
        setTimeout(() => {
          // 设置滚动位置
          scrollView.scrollLeft = targetScrollLeft;
        }, 0);
      }
    },
    
    // 加载水平滚动分类数据
    loadCategoryList() {
      this.loading = true;
      
      const data = {
        parentId: '', // 顶级分类
        // attribute: 8,
        // h5: this.activityId || 8
      };
      
      // 根据activityId选择不同的API
      let apiPromise;
      if (this.activityId === 13 || this.activityId === 16) {
        // activityId为13或16时使用指定接口
        apiPromise = getcategoryInfo({
          parentId: '',
          h5: this.activityId,
          attribute: this.activityId
        });
      } else {
        // 其他情况使用原有接口
        apiPromise = GetChannelDataApi(data);
      }
      
      return new Promise((resolve, reject) => {
        apiPromise
          .then((res) => {
            console.log("顶部分类数据", res);
            if (res && res.data && Array.isArray(res.data)) {
              if (this.activityId === 13 || this.activityId === 16) {
                // activityId为13或16时，使用返回数据的子分类作为水平滚动导航数据
                this.categoryList = res.data[0] && res.data[0].categories ? res.data[0].categories : [];
              } else {
                // 其他情况直接使用返回数据
                this.categoryList = res.data;
              }
              
              // 如果有分类数据，默认选中第一个
              if (this.categoryList && this.categoryList.length > 0) {
                const firstCategory = this.categoryList[0];
                this.categoryId = firstCategory.categoryId;
                
                // 设置默认选中的索引，根据activityId选择不同的索引变量
                if (this.activityId === 13 || this.activityId === 16) {
                  this.selIndex = 0;
                } else {
                  this.getIndex = 0;
                }
                
                // 只有在正常的子分类策略下才自动加载子分类
                if (this.currentSubCategoryStrategy !== 'topLevel') {
                  this.loadSubCategories(this.categoryId);
                }
                console.log('选中的分类ID:', this.categoryId);
              }
            } else {
              // 如果API返回的数据不符合预期，使用mock数据
              this.useMockData();
            }
            resolve();
          })
          .catch(error => {
            console.error("加载顶部分类数据失败:", error);
            // 如果API调用失败，使用mock数据
            this.useMockData();
            reject(error);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    
    // 使用mock数据
    useMockData() {
      // mock 顶部分类数据
      this.categoryList = [
        { categoryId: '1', categoryName: '新鲜蔬菜', icon: 'https://img.zhujiaxian.com/2024/07/880b5737c5ef4a099f6c5d0326d35d54.png' },
        { categoryId: '2', categoryName: '水果生鲜', icon: 'https://img.zhujiaxian.com/2024/07/880b5737c5ef4a099f6c5d0326d35d54.png' },
        { categoryId: '3', categoryName: '肉禽蛋奶', icon: 'https://img.zhujiaxian.com/2024/07/880b5737c5ef4a099f6c5d0326d35d54.png' },
        { categoryId: '4', categoryName: '水产海鲜', icon: 'https://img.zhujiaxian.com/2024/07/880b5737c5ef4a099f6c5d0326d35d54.png' },
        { categoryId: '5', categoryName: '粮油副食', icon: 'https://img.zhujiaxian.com/2024/07/880b5737c5ef4a099f6c5d0326d35d54.png' },
        { categoryId: '6', categoryName: '休闲零食', icon: 'https://img.zhujiaxian.com/2024/07/880b5737c5ef4a099f6c5d0326d35d54.png' }
      ];
      
      // 默认选中第一个分类
      if (this.categoryList.length > 0) {
        this.categoryId = this.categoryList[0].categoryId;
        // mock 子分类数据
        this.subCategoryList = [
          { categoryId: '101', categoryName: '叶菜类' },
          { categoryId: '102', categoryName: '根茎类' },
          { categoryId: '103', categoryName: '瓜茄类' },
          { categoryId: '104', categoryName: '菌菇类' },
          { categoryId: '105', categoryName: '豆类' },
          { categoryId: '106', categoryName: '花菜类' }
        ];
        
        // mock 商品数据
        this.productList = [
          { prodId: '1001', prodName: '有机生菜 新鲜蔬菜 500g装', price: '9.9', pic: 'https://img.zhujiaxian.com/2024/07/880b5737c5ef4a099f6c5d0326d35d54.png' },
          { prodId: '1002', prodName: '新鲜上海青 农家自种 400g装', price: '5.8', pic: 'https://img.zhujiaxian.com/2024/07/880b5737c5ef4a099f6c5d0326d35d54.png' },
          { prodId: '1003', prodName: '油麦菜 新鲜蔬菜 300g装', price: '6.5', pic: 'https://img.zhujiaxian.com/2024/07/880b5737c5ef4a099f6c5d0326d35d54.png' },
          { prodId: '1004', prodName: '菠菜 新鲜蔬菜 350g装', price: '7.8', pic: 'https://img.zhujiaxian.com/2024/07/880b5737c5ef4a099f6c5d0326d35d54.png' },
          { prodId: '1005', prodName: '空心菜 新鲜蔬菜 400g装', price: '6.9', pic: 'https://img.zhujiaxian.com/2024/07/880b5737c5ef4a099f6c5d0326d35d54.png' },
          { prodId: '1006', prodName: '娃娃菜 新鲜蔬菜 3颗装', price: '8.9', pic: 'https://img.zhujiaxian.com/2024/07/880b5737c5ef4a099f6c5d0326d35d54.png' }
        ];
        
        this.hasMore = false;
        this.loading = false;
      }
    },
    
    // 加载子分类数据
    loadSubCategories(categoryId) {
      // 根据子分类加载策略执行不同的逻辑
      if (this.currentSubCategoryStrategy === 'topLevel') {
        // 策略1: 加载顶级分类数据显示在子分类菜单中
        const data = {
          parentId: '', // 顶级分类
        };
        
        // 只有当活动ID不为8和12时才传递h5和attribute参数
        if (this.activityId !== 8 && this.activityId !== 12) {
          data.h5 = this.activityId;
          data.attribute = this.activityId;
        }
        
        GetChannelDataApi(data)
          .then((res) => {
            console.log("顶部分类数据(用于子分类菜单)", res);
            
            // 处理不同活动ID的数据结构
            let categoryData = [];
            if (this.activityId === 13 || this.activityId === 16) {
              // activityId为13或16时，使用分类详情接口返回的数据
              categoryData = res.data[0] && res.data[0].categories ? res.data[0].categories : [];
            } else if (this.activityId !== 8) {
              // 其他非8的活动ID，数据在data[0].categories字段中
              categoryData = res.data[0] && res.data[0].categories ? res.data[0].categories : [];
            } else {
              // activityId为8时，直接使用res.data
              categoryData = res.data || [];
            }
            
            if (categoryData.length > 0) {
              this.subCategoryList = categoryData;
              this.selIndex = 0;
              
              // 默认选中第一个分类
              this.categoryId = this.subCategoryList[0].categoryId;
              this.loadProducts();
            } else {
              // 如果没有数据，清空子分类列表
              this.subCategoryList = [];
            }
          })
          .catch(error => {
            console.error("加载子分类数据失败:", error);
          });
      } else {
        // 策略2: 加载正常的子分类数据
        const data = {
          parentId: categoryId || '',
          // attribute: 8,
        };
        
        // 只有当活动ID不为8且不为12时才传递h5参数
        if (this.activityId !== 8 && this.activityId !== 12) {
          data.h5 = this.activityId;
        }
        
        GetChannelDataApi(data)
          .then((res) => {
            console.log("子分类数据", res);
            // 当活动ID不为8时，数据在data.categories字段中
              const categoryData = this.activityId !== 8 ? (res && res.data && res.data.categories) : (res && res.data);
            if (categoryData && Array.isArray(categoryData) && categoryData.length > 0) {
              this.subCategoryList = categoryData;
              this.selIndex = 0;
              
              // 如果有子分类，默认选中第一个
              if (this.subCategoryList && this.subCategoryList.length > 0) {
                this.categoryId = this.subCategoryList[0].categoryId;
                this.loadProducts();
              }
            } else {
              // 如果没有子分类，使用当前分类ID加载商品
              this.subCategoryList = [];
              this.loadProducts();
            }
          })
          .catch(error => {
            console.error("加载子分类数据失败:", error);
          });
      }
    },
  },
  
  
  created() {
    // 从路由中获取活动ID
    const urlActivityId = getActivityIdFromRoute(this.$route);
    // 从全局状态获取活动ID
    const globalActivityId = this.$store.getters.getActivityId;
    
    // 如果URL中存在活动ID，优先使用URL中的活动ID
    if (urlActivityId) {
      this.activityId = urlActivityId;
      // 当URL中的活动ID与全局状态中的不同时，才更新全局状态
      if (urlActivityId !== globalActivityId) {
        this.$store.dispatch('updateActivityId', urlActivityId);
      }
    } else if (globalActivityId) {
      // URL中没有活动ID，但全局状态中有，使用全局状态中的活动ID
      this.activityId = globalActivityId;
    } else {
      // 既没有URL活动ID也没有全局活动ID时，使用默认设置
      this.activityId = 8;
    }
    
    // 判断是否需要重新加载数据
    if (!this.$route.meta.isBack) {
      // 加载顶部分类数据
      this.loadCategoryList().then(() => {
        // 分类数据加载完成后，如果是顶级分类策略，加载一级分类到子分类菜单
        if (this.currentSubCategoryStrategy === 'topLevel') {
          this.loadSubCategories('');
        }
      });
    }
    
    // 恢复成默认值，避免isBack一直是true
    this.$route.meta.isBack = false;
  }
};
</script>
<style scoped lang="less">
/* 主容器样式 */
.category-container {
  height: 100vh;
  overflow: hidden; /* 禁止整个页面滚动 */
  position: relative;
}

/* 搜索栏样式 */
.search-bar {
  padding: 10px 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.search-box {
  display: flex;
  background: #f7f7f7;
  align-items: center;
  height: 30px;
  width: 92%;
  border-radius: 25px;
  text-align: center;
  margin: auto;
  border: 1px solid #8fc31f;
}

.sear-input {
  font-size: 14px;
  color: #c5c5c5;
}

.search-img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

/* 水平滚动区域样式 */
.horizontal-scroll-wrapper {
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  height: 88px;
  background-color: #fff;
  z-index: 998;
  border-bottom: 1px solid #f2f2f2;
}

.horizontal-scroll-view {
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
}

.scroll-container {
  padding: 10px;
  display: flex;
}

.category-item {
  display: inline-block;
  margin-right: 15px;
  text-align: center;
}

.category-item div {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.category-item img {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  margin-bottom: 5px;
}

.category-title {
  font-size: 12px;
}

.category-title .active {
  color: #8fc31f;
  font-weight: 500;
}

/* 主内容区域样式 */
.main-content {
  display: flex;
  height: auto;
  min-height: calc(100vh - 2.4rem);
}

/* 当水平滚动导航隐藏时，主内容区域上边距 */
.horizontal-scroll-wrapper[style*="display: none"] + .main-content {
  margin-top: 1.333rem;
  height: calc(100vh - 2.4rem);
}

/* 当活动ID为9时（既没有搜索栏也没有水平滚动导航），主内容区域直接从顶部开始 */
.search-bar[style*="display: none"] + .horizontal-scroll-wrapper[style*="display: none"] + .main-content {
  margin-top: 0;
  height: 100vh;
}

/* 当水平滚动导航显示时，默认的主内容区域上边距 */
.horizontal-scroll-wrapper:not([style*="display: none"]) + .main-content {
  margin-top: 3.68rem;
  height: calc(100vh - 4.747rem);
}

/* 当水平滚动导航显示且活动ID为13时，调整主内容区域的上边距 */
.horizontal-scroll-wrapper:not([style*="display: none"]) + .main-content.activity-id-13 {
  margin-top: 1.33333rem;
  height: calc(100vh - 3.73333rem);
}

/* 当活动ID为9时，左侧菜单和右侧商品列表直接从顶部开始排列 */
.search-bar[style*="display: none"] + .horizontal-scroll-wrapper[style*="display: none"] + .main-content .left-menu,
.search-bar[style*="display: none"] + .horizontal-scroll-wrapper[style*="display: none"] + .main-content .product-content {
  height: 100vh;
}

/* 左侧菜单样式 */
.left-menu {
  width: 25%;
  background-color: #f9f9fb;
  overflow-y: hidden; /* 禁止左侧菜单上下滑动 */
}

.menu-item {
  padding: 15px 10px;
  text-align: center;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #f2f2f2;
}

.menu-item.active {
  background-color: #fff;
  color: #8fc31f;
  font-weight: 500;
  position: relative;
}

.menu-item.active:before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  background-color: #8fc31f;
}

/* 右侧商品列表区域样式 */
.product-content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #fff;
}

/* 当应用full-width类时，商品内容区域占满宽度 */
.main-content .product-content.full-width {
  width: 100% !important;
}

/* 当活动ID为10时，商品内容区域占据全部宽度并保持垂直滚动 */
.product-content.full-width {
  width: 100% !important;
  height: calc(100vh - 2.4rem) !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important;
  position: relative;
  flex: none !important;
}

/* 为活动ID为10的特定情况添加样式，确保主内容区域和商品内容区域的高度正确 */
.horizontal-scroll-wrapper[style*="display: none"] + .main-content {
  .product-content.full-width {
    height: calc(100vh - 2.4rem) !important;
  }
}

/* 确保商品列表可以正常滚动 */
.product-content.full-width .product-list {
  min-height: calc(100% - 44px); /* 减去排序栏高度 */
}

/* 优化滚动体验 */
.product-content.full-width::-webkit-scrollbar {
  display: none; /* 隐藏滚动条但保持滚动功能 */
}

/* 排序栏样式 */
.content-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  padding: 10px 15px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  z-index: 10;
}

.comprehensive,
.price {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #0d1401;
  width: 50%;
}

.price img {
  width: 9px;
  height: 5px;
  display: block;
  margin-left: 3px;
}

.price img:first-child {
  margin-bottom: 2px;
}

.active-text {
  color: #8fc31f;
}

/* 商品列表样式 */
.product-list {
  padding: 10px;
}

.product-item {
  margin-bottom: 15px;
}

.product-link {
  display: flex;
  padding: 10px;
  border-radius: 8px;
  background-color: #f9f9fb;
}

.product-image {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
}

.product-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info {
  flex: 1;
  margin-left: 10px;
  position: relative;
}

.product-name {
  display: block;
  font-size: 14px;
  color: #333;
  line-height: 1.4;
  max-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 5px;
}

.product-price {
  font-size: 16px;
  color: #ff6900;
  position: absolute;
  bottom: 0;
  left: 0;
}

.product-price--big {
  font-size: 18px;
  font-weight: 600;
}
.product-original-price {
  font-size: 12px;
  color: #999;
  text-decoration: line-through;
  margin-left: 5px;
}

.product-cart {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 24px;
  height: 24px;
  background: url("http://img.zhujiaxian.com/2023/03/d91bac986f2b4421bd85d93cc3843004.png") 50% no-repeat;
  background-size: 100% 100%;
}

/* 加载提示样式 */
.loading-wrapper {
  text-align: center;
  padding: 20px 0;
}

.loading-gif {
  width: 50px;
  height: 50px;
  display: inline-block;
}

.no-more-tip {
  text-align: center;
  padding: 20px 0;
  color: #999;
  font-size: 14px;
}

/* 重置默认样式 */
a,
input {
  outline: none;
}

ul,
ol,
li {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-bottom: 2px;
}
.loading-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 999;
}

.loading-gif {
  width: 100px;
  height: 100px;
  display: inline-block;
}

.no-more-tip {
  text-align: center;
  padding: 20px 0;
  color: #999;
  font-size: 14px;
  width: 100%;
}
</style>
